const STYLE_BY_CATEGORY = Object.freeze({
  system: ['system-notice'], update: ['system-notice', 'cheap-flyer'], maintenance: ['system-notice'],
  event: ['cheap-flyer'], warning: ['warning-note'], rumor: ['sticky-note', 'graffiti-scrap'],
  jobs: ['lined-paper', 'cheap-flyer'], requests: ['lined-paper'], graffiti: ['graffiti-scrap'],
});
const ROTATIONS = [-4, -2, -1, 1, 2, 3];
const SIZES = ['small', 'medium', 'large'];
const TINTS = ['cream', 'yellowed', 'pink', 'blue', 'white', 'nicotine'];
const ATTACHMENTS = ['pin-red.svg', 'pin-blue.svg', 'pin-green.svg', 'tape-mask-1.svg', 'tape-mask-2.svg', 'tape-mask-3.svg'];
const STAINS = ['', '', 'stain-coffee-ring.svg', 'stain-grease.svg'];

function hashText(value) {
  let hash = 2166136261;
  for (const char of String(value || 'board-note')) { hash ^= char.charCodeAt(0); hash = Math.imul(hash, 16777619); }
  return hash >>> 0;
}
function pick(items, hash, shift = 0) { return items[(hash >>> shift) % items.length]; }

export function noteAppearance(post) {
  const hash = hashText(post.sourceKey || post.reference || post.id || post.title);
  const category = String(post.category || 'system').toLowerCase();
  const families = STYLE_BY_CATEGORY[category] || ['system-notice', 'sticky-note', 'lined-paper', 'cheap-flyer', 'warning-note', 'graffiti-scrap'];
  return {
    family: pick(families, hash), rotation: pick(ROTATIONS, hash, 4), size: post.pinned ? 'large' : pick(SIZES, hash, 8),
    tint: pick(TINTS, hash, 12), attachment: pick(ATTACHMENTS, hash, 16), stain: pick(STAINS, hash, 20),
  };
}

export function BulletinBoardNote({ post, onOpen }) {
  const look = noteAppearance(post);
  const label = `${post.pinned ? 'Pinned ' : ''}${post.category || 'notice'}: ${post.title}`;
  return (
    <button type="button" className={`bulletin-note ${look.family} size-${look.size} tint-${look.tint} ${post.pinned ? 'pinned' : ''}`}
      style={{ '--note-rotation': `${look.rotation}deg` }} aria-label={label} onClick={() => onOpen(post)} onDoubleClick={() => onOpen(post)}>
      <img className={`bulletin-note-attachment ${look.attachment.startsWith('tape') ? 'tape' : 'pin'}`} src={`./ui/board/${look.attachment}`} alt="" aria-hidden="true" />
      {look.stain && <img className="bulletin-note-stain" src={`./ui/board/${look.stain}`} alt="" aria-hidden="true" />}
      <span className="bulletin-note-category">{String(post.category || 'notice').toUpperCase()}{post.pinned ? ' · PINNED' : ''}</span>
      <strong>{post.title}</strong>
      <span className="bulletin-note-preview">{post.body}</span>
      <small>{post.author || 'The Dope Man System'}</small>
    </button>
  );
}
